module.exports = __webpack_public_path__ + "img/vr1.cedac582.jpg";